import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { AloDbMesureUnite } from './AloDbMesureUnite';
import { AloMission } from '../alo/AloMission';
import { AloDbMission, IAloDbMissionConstParam } from './AloDbMission';
import { ISmartResult,getDefaultSmartResult } from '../iris/smartMission/ISmartResult';
import { ISmartMission,getDefaultSmartMission } from '../iris/smartMission/ISmartMission';

import { boundingExtent } from 'ol/extent';
import { SimulationStatus } from '@/enum/SimulationStatus';

export interface IAloDbMissionVirtualConstParam extends IAloDbBaseConstParam {    
    VIM_LIBELLE:string|null    
    VIM_DATADD:string|null
    VIM_DATDEL:string|null        
    VIM_PARAM_JSON:string|null    
    VIM_RESULT_JSON:string|null  
    VIM_NAME:string|null        
    VIM_COMPANY:string|null      
    VIM_ITERATION:number|null    
    VIM_STATUS:number|null 
    missionBase:IAloDbMissionConstParam
  }

export class AloDbMissionVirtual extends AloDbBase {
            
    public VIM_LIBELLE:string|null
    public VIM_DATADD:Date|null
    public VIM_DATDEL:Date|null    
    public VIM_PARAM_JSON:string|null    
    public VIM_RESULT_JSON:string|null        
    public VIM_NAME:string|null        
    public VIM_COMPANY:string|null      
    public VIM_ITERATION:number|null             
    public VIM_STATUS:number    
    public missionBase:AloDbMission
    public mission:AloMission
    public result:ISmartResult
    public param:ISmartMission
    
    constructor({VIM_LIBELLE,VIM_DATADD,VIM_DATDEL,VIM_PARAM_JSON,VIM_RESULT_JSON,VIM_NAME,VIM_COMPANY,VIM_ITERATION,VIM_STATUS,missionBase,...args }:IAloDbMissionVirtualConstParam = {} as IAloDbMissionVirtualConstParam) {
        super(args)        
        this.VIM_LIBELLE = VIM_LIBELLE   
        this.VIM_STATUS = VIM_STATUS ?? SimulationStatus.running
        this.VIM_DATADD =  VIM_DATADD?new Date(VIM_DATADD):null
        this.VIM_DATDEL =  VIM_DATDEL?new Date(VIM_DATDEL):null    
        this.VIM_PARAM_JSON = VIM_PARAM_JSON   
        this.VIM_RESULT_JSON = VIM_RESULT_JSON 
        this.VIM_NAME = VIM_NAME
        this.VIM_COMPANY = VIM_COMPANY
        this.VIM_ITERATION = VIM_ITERATION
        this.missionBase = new AloDbMission(missionBase)
        this.result = {...getDefaultSmartResult(),...JSON.parse(VIM_RESULT_JSON??'{}')} as ISmartResult
        this.param = {...getDefaultSmartMission(),...JSON.parse(VIM_PARAM_JSON??'{}')} as ISmartMission
            
               
        this.mission = AloDbMissionVirtual.buildAloMission(this)
               
    }   

    static buildAloMission(missionvirtual:AloDbMissionVirtual,detailLoaded=false)
    {

        const mesureTypeExArray = [
            {MET_KEY:"SIMU_TEMPERATURE",mesureUniteEx:{MUT_SYMBOL:"°"},MET_CONFIG_JSON:JSON.stringify({name:"Température"})},
            {MET_KEY:"SIMU_SALINITY",mesureUniteEx:{MUT_SYMBOL:"PSU"},MET_CONFIG_JSON:JSON.stringify({name:"Salinity"})}
        ]

        //@ts-ignore
        const mission =  new AloMission({detailLoaded: detailLoaded || missionvirtual.VIM_STATUS < 0 || missionvirtual.VIM_STATUS == 10,misId:missionvirtual.missionBase.MIS_ID,misIdx:missionvirtual.missionBase.MIS_IDX,misLibelle:missionvirtual.missionBase.MIS_LIBELLE,gliId:missionvirtual.missionBase.GLI_ID,ensId:missionvirtual.missionBase.gliderEnsId,yoArray:missionvirtual.result.surfacing_points.map((s,idx) => ({
            yosId:(-idx),
            //@ts-ignore
            yosCycle:s?.at(0),heading:s?.at(4),cr:s?.at(6),cf:s?.at(5),yoGpsLat:s?.at(2),yoGpsLon:s?.at(3),yoGpsDatTime:s?.at(1),batteries:s?.at(7)
        }))    
        //@ts-ignore 
        ,isVirtual:true,mesureTypeExArray})

        //on prend en compte les points du mission plan pour la zone de zoom auto
        const gpsPoint =  missionvirtual.param.mission_plan.wpts?.filter(wpt => wpt.wpt_lat !=null && wpt.wpt_lon != null)?.map(wpt => [wpt.wpt_lon,wpt.wpt_lat]) ?? []
        //@ts-ignore
        const yos = mission.yoArray.filter(y => y.yoGpsLat !=null && y.yoGpsLon != null)?.map(y => [y.yoGpsLon!, y.yoGpsLat!]) ?? []    
        mission._extent = boundingExtent([...gpsPoint,...yos])              
        
        //reaafecte l'état des données science et de navigation si la mission etait finished ou aborted avant
        if(missionvirtual?.mission && (missionvirtual.result.simulation_state == "finished" || missionvirtual.result.simulation_state == "aborted")) {
            mission._dataScienceLoaded = missionvirtual.mission._dataScienceLoaded
            mission._dataScienceLoading = missionvirtual.mission._dataScienceLoading
            mission.dataScience = missionvirtual.mission.dataScience
            
            mission._dataNavigationLoaded = missionvirtual.mission._dataNavigationLoaded
            mission._dataNavigationLoading = missionvirtual.mission._dataNavigationLoading
            mission.dataNavigation = missionvirtual.mission.dataNavigation
        }

        return mission

    }


    static createAloDbMissionVirtualArray(datas:any) {
        return new AloBaseArray(AloDbMissionVirtual,datas)
    }

    static createAloDbMissionVirtualWithDetail(data:any) {
        return new AloDbMissionVirtual({...data,detailLoaded:true})
    }
}